import React, { useEffect, useState } from "react";

const Footer = () => {
   const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [openSection, setOpenSection] = useState({
        information: false,
        quickLinks: false,
        getHelp: false,
    });

    useEffect(() => {
    const handleResize = () => {
        const mobile = window.innerWidth < 768;
        setIsMobile(mobile);

        if (!mobile) {
            setOpenSection({
                information: true,
                quickLinks: true,
                getHelp: true,
            });
        } else {
            setOpenSection({
                information: false,
                quickLinks: false,
                getHelp: false,
            });
        }
    };

    handleResize(); 
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
}, []);

    const toggleAccordion = (section) => {
        if (isMobile) {
            setOpenSection((prev) => ({
                ...prev,
                [section]: !prev[section],
            }));
        }
    };
   
    return (
        <>  
            <div className="row align-items-stretch">
                <div className="col-lg-4 map-p-img">
                    <div
                        className="map-common-box"
                        style={{
                            border: '1px solid #fff',
                            boxShadow: '0px 0px 10px 2px #aaaaaa'
                        }}
                    >
                        <img
                            src="./assets/img/about/about.jpg"
                            alt="About Welbeing"
                            className="map-about-img"
                        />
                    </div>
                </div>

                <div className="col-lg-8 map-p-map">
                    <div
                        className="map-common-box"
                        style={{
                            border: '1px solid #fff',
                            boxShadow: '0px 0px 10px 2px #aaaaaa'
                        }}
                    >
                        <iframe
                            title="Location Map"
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3916.2407539208652!2d77.0170682750454!3d11.020554889143442!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba857a6381ea5fb%3A0x31660aa6f5e1598e!2sWelbeing%20Bags%20-%20Jute%20Bags%2C%20Cotton%20Bags%2C%20Thamboolam%20Bags%2C%20Logo%20Printing%20Bags%2C%20Market%20Bags!5e0!3m2!1sen!2sin!4v1697482580058!5m2!1sen!2sin"
                            width="100%"
                            height="100%"
                            style={{ border: 0 }}
                            allowFullScreen
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                        />
                    </div>
                </div>
            </div>
            <footer className="footer-document footer-document2 ratio_asos mb-xxl">
                <div className="container-lg">
                    <div className="main-footer">
                        <div className="row gy-3 gy-md-4 gy-xl-0">
                            <div className="col-xl-3 col-lg-4 col-md-6">
                                <div className="content-box">
                                    <img className="logo" src="/assets/img/logo/logowhite.png" alt="logo-white" />
                                    <ul>
                                        <li>
                                            <i data-feather="map-pin"></i> 
                                            <span className="text-start">
                                                No. 32A, New No.40,<br /> 
                                                5th St, Lakshmipuram,<br /> 
                                                Masakali Palayam, Peelamedu<br /> 
                                                Tamil Nadu 641004
                                            </span>
                                        </li>
                                        <li>
                                            <i data-feather="phone"></i>
                                            <a className="nav" href="tel:+919865651212">
                                                <span>+91 904747 3959</span>
                                            </a>
                                        </li>
                                        <li>
                                            <i data-feather="mail"></i>
                                            <a className="nav" href="mailto:welbeinginfo@gmail.com">
                                                <span>welbeinginfo@gmail.com</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div className="nav-footer  col-lg-2 col-md-4 order-md-3 order-lg-2">
                                <div className={`nav content-box ${openSection.information ? "open  d-md-block" : "d-sm-block"}`}>
                                    <h5 className="heading-footer line-style"  onClick={() => toggleAccordion("information")} style={{ cursor: isMobile ? "pointer" : "default" }} >Information</h5>
                                    {(openSection.information || !isMobile) && (
                                        <ul>
                                            <li><a className="nav" href="/privacypolicy">Privacy Policy</a></li>
                                            <li><a className="nav" href="/termscondition">Terms & Conditions</a></li>
                                            <li><a className="nav" href="/returnpolicy">Return Policy</a></li>
                                            <li><a className="nav" href="/shipping">Shipping/Delivery Policy</a></li>
                                        </ul>
                                    )}
                                </div>
                            </div>

                            <div className="nav-footer col-xl-2 col-lg-3 col-md-4 order-md-4 order-lg-3">
                                <div className={`nav content-box ${openSection.quickLinks ? "open  d-md-block" : "d-sm-block"}`}>
                                    <h5 className="heading-footer line-style"   onClick={() => toggleAccordion("quickLinks")} style={{ cursor: isMobile ? "pointer" : "default" }}>Quick Links</h5>
                                     {(openSection.quickLinks || !isMobile) && (
                                        <ul>
                                            <li><a className="nav" href="/">Home</a></li>
                                            <li><a className="nav" href="/about">About Us</a></li>
                                            <li><a className="nav" href="/contact">Contact</a></li>
                                            <li><a className="nav" href="/faq">FAQ</a></li>
                                        </ul>
                                    )}
                                </div>
                            </div>

                            <div className="nav-footer col-xl-2 col-lg-3 col-md-4 order-md-5 order-lg-4">
                                <div className={`nav content-box ${openSection.getHelp ? "open  d-md-block" : "d-sm-block"}`}>
                                    <h5 className="heading-footer line-style" onClick={() => toggleAccordion("getHelp")} style={{ cursor: isMobile ? "pointer" : "default" }}>Get Help</h5>
                                    {(openSection.getHelp || !isMobile) && (
                                        <ul>
                                            <li><a className="nav" href="/accounts">Your Orders</a></li>
                                            <li><a className="nav" href="/accounts">Your Account</a></li>
                                            <li><a className="nav" href="/accounts">Track Order</a></li>
                                            <li><a className="nav" href="/wishlist">Your Wishlist</a></li>
                                        </ul>
                                    )}
                                </div>
                            </div>

                            <div className="col-xl-3 col-md-6 col-lg-4 order-md-2 order-lg-5">
                                <div className="content-box">
                                    <h5 className="heading-footer line-style text-start">Follow Us</h5>
                                    <div className="follow-wrap">
                                        <ul>
                                            <li>
                                                <a href="https://www.facebook.com/welbeing.bags.gifts" target="_blank" rel="noopener noreferrer">
                                                    <img src="assets/img/icons/fb.svg" alt="facebook" />
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://www.instagram.com/welbeing.bags.gifts/" target="_blank" rel="noopener noreferrer">
                                                    <img src="assets/img/icons/inta.svg" alt="instagram" />
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://www.youtube.com/@welbeing_bags_gifts" target="_blank" rel="noopener noreferrer">
                                                    <img src="assets/img/icons/yt.svg" alt="youtube" />
                                                </a>
                                            </li>
                                        </ul>
                                    </div>

                                    <div className="subscribe-box">
                                        <h5 className="text-start">Newsletter Sign Up</h5>
                                        <p>Receive our latest updates about our products & promotions.</p>
                                    </div>

                                    <form action="javascript:void(0)" className="footer-form">
                                        <input required type="email" className="form-control" placeholder="Your email address" />
                                        <div className="btn-style4 btn-theme py-0">
                                            <button type="submit" className="btn">
                                                <span className="corner-wrap left-top">
                                                    <span className="corner"></span>
                                                </span>
                                                <span className="corner-wrap right-bottom">
                                                    <span className="corner"></span>
                                                </span>
                                                Submit
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="sub-footer">
                        <div className="row gy-3">
                            <div className="col-md-6">
                                <ul>
                                    <li>
                                        <a href="javascript:void(0)">
                                            <img src="assets/icons/png/1.png" className="img-fluid blur-up lazyload" alt="payment icon" />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0)">
                                            <img src="assets/icons/png/2.png" className="img-fluid blur-up lazyload" alt="payment icon" />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0)">
                                            <img src="assets/icons/png/3.png" className="img-fluid blur-up lazyload" alt="payment icon" />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0)">
                                            <img src="assets/icons/png/4.png" className="img-fluid blur-up lazyload" alt="payment icon" />
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-md-6">
                                <p className="mb-0">
                                    © {new Date().getFullYear()}, Welbeing All Rights Reserved. Made with heart by{" "}
                                    <a className="text-white" href="https://sninfoserv.com/" target="_blank" rel="noopener noreferrer">
                                        SN Infoserv
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>

            <footer className="mobile-menu-footer d-sm-none">
                <ul>
                    <li>
                        <a href="/" className="active">
                            <i data-feather="home"></i>
                            <span>Home</span>
                        </a>
                    </li>
                    <li>
                        <a href="/search" className="search-link">
                            <i data-feather="search"></i>
                            <span>Search</span>
                        </a>
                    </li>
                    <li>
                        <a href="/cart">
                            <i data-feather="shopping-bag"></i>
                            <span>Cart</span>
                        </a>
                    </li>
                    <li>
                        <a href="/wishlist">
                            <i data-feather="heart"></i>
                            <span>Wishlist</span>
                        </a>
                    </li>
                    <li>
                        <a href="/accounts">
                            <i data-feather="user"></i>
                            <span>Account</span>
                        </a>
                    </li>
                </ul>
            </footer>
        </>
    );
};

export default Footer;